import Rule from "../../../common/rule";
import DriveEndType from "../../enums/drive-end-type";
import FootballState from "../../state/football-state";
import { getTouchbackYardline } from "../../utils/context-utils";

export default class TouchBack extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.TouchBack;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const fumbledOobNoRecov =
            play.historyContains(FootballState.OutOfBounds) &&
            play.historyContains(FootballState.Fumble) &&
            play.getPreceedingFragment(fragment, [
                FootballState.Fumble,
                FootballState.FumbleNotRecovered,
                FootballState.FumbleRecovered
            ])?.associatedState === FootballState.Fumble;
        const isHomeTeamEndZone = gameContext.fieldPosition <= 0;
        const isAwayTeamEndZone =
            gameContext.fieldPosition >=
            gameContext.gameConfig.general.fieldLength;

        const { associatedState: state } =
            play.getPreceedingFragment(fragment, [
                FootballState.Punt,
                FootballState.CflKick,
                FootballState.KickOff,
                FootballState.FieldGoal,
                FootballState.Deuce
            ]) || {};

        if (fumbledOobNoRecov && (isHomeTeamEndZone || isAwayTeamEndZone)) {
            gameContext.setPossessionForTeamId(
                isHomeTeamEndZone
                    ? gameContext.homeTeamId
                    : gameContext.awayTeamId
            );
        } else if (
            state !== FootballState.FieldGoal &&
            state !== FootballState.Deuce
        ) {
            gameContext.switchPossession();
        }

        const { homeTeamHasPossession, gameConfig } = gameContext;
        const possessionChanged =
            play.contextSnapshot.homeTeamHasPossession !==
            homeTeamHasPossession;
        ruleContext.setAwardFirstDown(true);
        gameContext.setFieldPosition(
            getTouchbackYardline(
                play.historyContains(FootballState.KickOff),
                homeTeamHasPossession,
                gameConfig
            )
        );
        if (possessionChanged) {
            gameContext.setDriveContext({
                triggerDrive: true,
                previousDriveEndType: this.getDriveEndType(state)
            });
        }

        return [];
    }

    getDriveEndType(state) {
        switch (state) {
            case FootballState.Punt:
            case FootballState.CflKick:
                return DriveEndType.Punt;
            default:
                return null;
        }
    }
}
